import * as Styled from "./style"; 

export const Line = () => (<Styled.Line />)